import React from "react"
import { SensaiComponentTextAccordion } from "../../../gql/generated/graphql"
import { Box } from "@mui/system"
import { Typography } from "@mui/material"
import MarkdownContent from "../../ui/MarkdownContent"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import AddIcon from "@mui/icons-material/Add"
import RemoveIcon from "@mui/icons-material/Remove"

const AccordionText = ({ card }: { card: SensaiComponentTextAccordion }) => {
  const [expanded, setExpanded] = React.useState<number>(-1)

  const handleChange = (panel: number) => (
    event: React.SyntheticEvent,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : -1)
  }

  const { textStyle, title, description, entries } = card
  const { textAlign, titleLevel } = textStyle ?? {
    textAlign: "left",
    titleLevel: "h3",
  }
  return (
    <Box
      data-aos="zoom-in"
      sx={{
        padding: "0",

        position: "relative",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",

          justifyContent:
            textAlign === "left"
              ? "start"
              : textAlign === "center"
              ? "center"
              : "end",
        }}
      >
        <Typography
          variant={titleLevel ?? "h3"}
          color={
            titleLevel === "h3" ? "var(--color-teal)" : "var(--color-dark)"
          }
          className={titleLevel === "h2" ? "gradientText" : ""}
          fontSize={
            titleLevel === "h2"
              ? "1.85rem"
              : titleLevel === "h3"
              ? "1.5rem"
              : "1.25rem"
          }
          lineHeight={
            titleLevel === "h2"
              ? "2.25rem"
              : titleLevel === "h3"
              ? "2.0rem"
              : "1.5rem"
          }
          fontWeight={
            titleLevel === "h2" ? 700 : titleLevel === "h3" ? 600 : 500
          }
          letterSpacing={
            titleLevel === "h2" ? "0.3px" : titleLevel === "h3" ? "0.3px" : 0
          }
        >
          {title}
        </Typography>
      </Box>

      {description && (
        <Box
          sx={{
            zIndex: "2",
            textAlign: textAlign,
            p: { textAlign: textAlign },
          }}
        >
          <MarkdownContent animate={false} content={description} />
        </Box>
      )}

      {entries && (
        <Box
          sx={{
            margin: "1rem 0",
            "& AccordionSummary": {
              margin: "0px !important",
              padding: "0.75rem 0",
            },
            "& AccordionDetails": {
              margin: "0px !important",
              color: "var(--color-grey-4)",
            },
          }}
        >
          {entries.map((entry, i) => {
            return (
              <Accordion
                key={i}
                expanded={expanded === i}
                onChange={handleChange(i)}
                sx={{ backgroundColor: "#F6F7F8" }}
              >
                <AccordionSummary
                  aria-controls="panel1-content"
                  id="panel1-header"
                  expandIcon={expanded === i ? <RemoveIcon /> : <AddIcon />}
                >
                  <Typography
                    component="h4"
                    fontWeight={600}
                    color={
                      expanded === i
                        ? "var(--color-teal)"
                        : "var(--color-grey-4)"
                    }
                  >
                    {entry?.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <MarkdownContent
                    animate={false}
                    content={entry?.description ?? ""}
                  />
                </AccordionDetails>
              </Accordion>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default AccordionText
